"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_CARD_FRAGMENT = void 0;
var helpers_1 = require("../../client/helpers");
exports.VIDEO_CARD_FRAGMENT = "\n  fragment VideoCardFragment on VideoCard {\n    updatedAt\n    position\n    targetExternalUrl\n    showAt\n    hideAt\n    buttonText\n    createdAt\n    targetExternalType\n    thumbnailUrl\n    type\n    title\n    targetChannelId\n    targetVideoId\n    id\n    targetExternalId\n    customOrder\n  }\n";
//# sourceMappingURL=fragments.js.map